module.exports = __webpack_public_path__ + "media/images/layers-811f3fa7d01bac6317e91f0f1cec8ecb.svg";